var _path, _path2, _ellipse, _g, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup2146 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 100,
    viewBox: "0 0 129 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.29 15.0043V16.2501C107.289 19.1703 106.343 22.0116 104.595 24.3505C102.846 26.6893 100.389 28.4003 97.5882 29.2283C94.7879 30.0563 91.795 29.9568 89.0558 28.9449C86.3166 27.9329 83.9779 26.0625 82.3885 23.6128C80.7992 21.1631 80.0442 18.2652 80.2364 15.3514C80.4285 12.4375 81.5574 9.66388 83.4547 7.44405C85.352 5.22423 87.916 3.67718 90.7644 3.03363C93.6127 2.39008 96.5928 2.68452 99.2602 3.87302",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.292 5.41675L93.75 18.972L89.6875 14.9095",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.375,
    cy: 91.875,
    rx: 64.375,
    ry: 8.125,
    fill: "#F0F2EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_800_15605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.9836 91.4334C90.6304 91.4334 91.1547 90.926 91.1547 90.3001C91.1547 89.6742 90.6304 89.1667 89.9836 89.1667C89.3368 89.1667 88.8125 89.6742 88.8125 90.3001C88.8125 90.926 89.3368 91.4334 89.9836 91.4334Z",
    fill: "#E1E7D7",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.866 91.4334C103.513 91.4334 104.038 90.926 104.038 90.3001C104.038 89.6742 103.513 89.1667 102.866 89.1667C102.22 89.1667 101.695 89.6742 101.695 90.3001C101.695 90.926 102.22 91.4334 102.866 91.4334Z",
    fill: "#E1E7D7",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6172 67.6333H85.3016L88.4402 82.8086C88.5473 83.3304 88.8406 83.7991 89.2688 84.1327C89.697 84.4663 90.2328 84.6435 90.7824 84.6333H102.166C102.715 84.6435 103.251 84.4663 103.679 84.1327C104.107 83.7991 104.401 83.3304 104.508 82.8086L106.382 73.3H86.4727",
    fill: "#E1E7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6172 67.6333H85.3016L88.4402 82.8086C88.5473 83.3304 88.8406 83.7991 89.2688 84.1327C89.697 84.4663 90.2328 84.6435 90.7824 84.6333H102.166C102.715 84.6435 103.251 84.4663 103.679 84.1327C104.107 83.7991 104.401 83.3304 104.508 82.8086L106.382 73.3H86.4727",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.25 44.1668C81.25 64.5834 55 82.0834 55 82.0834C55 82.0834 28.75 64.5834 28.75 44.1668C28.75 37.2048 31.5156 30.528 36.4384 25.6052C41.3613 20.6824 48.0381 17.9167 55 17.9167C61.9619 17.9167 68.6387 20.6824 73.5616 25.6052C78.4844 30.528 81.25 37.2048 81.25 44.1668Z",
    fill: "#E1E7D7",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52.9167C59.8325 52.9167 63.75 48.9992 63.75 44.1667C63.75 39.3343 59.8325 35.4167 55 35.4167C50.1675 35.4167 46.25 39.3343 46.25 44.1667C46.25 48.9992 50.1675 52.9167 55 52.9167Z",
    fill: "#E1E7D7",
    stroke: "#5F6C4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_800_15605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.1067,
    height: 27.2,
    fill: "white",
    transform: "translate(79.4453 66.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup2146);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Group 2146.58e86ea3f0d57dafca38688ac8a374b4.svg";